import React from 'react'

export const SkillCard = (props) => {
    return (
        <>
            <div className="skillCard" data-aos="fade-up">
                <div className="skillCardImg">
                    <box-icon color='var(--font-color)' size="cssSize" type='logo' animation='tada-hover' name={props.skillLogo}></box-icon>
                </div>
                <div className="skillCardTitle">
                    <h5>{props.SkillName}</h5>
                </div>
            </div>
        </>
    )
}